var map = {
	"./asset-hyperlink.json": 9085,
	"./blockquote.json": 67375,
	"./document.json": 43789,
	"./embedded-asset-block.json": 36155,
	"./embedded-entry-block.json": 68287,
	"./embedded-entry-inline.json": 65217,
	"./embedded-resource-block.json": 29247,
	"./embedded-resource-inline.json": 66369,
	"./entry-hyperlink.json": 22869,
	"./heading-1.json": 48810,
	"./heading-2.json": 655,
	"./heading-3.json": 29616,
	"./heading-4.json": 12141,
	"./heading-5.json": 57398,
	"./heading-6.json": 79947,
	"./hr.json": 92126,
	"./hyperlink.json": 46844,
	"./list-item.json": 56506,
	"./ordered-list.json": 57452,
	"./paragraph.json": 61832,
	"./resource-hyperlink.json": 70419,
	"./table-cell.json": 73247,
	"./table-header-cell.json": 72759,
	"./table-row.json": 74763,
	"./table.json": 91150,
	"./text.json": 55775,
	"./unordered-list.json": 16375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76960;